export function parseSafetyContour(safetyContour) {
  let contours;
  if (safetyContour instanceof Array) {
    contours = safetyContour;
  } else {
    contours = (`${safetyContour}`).split(',');
    contours[0] *= 1;
    if (contours.length < 3) {
      contours = [contours[0], contours[0], contours[0]];
    } else {
      contours[1] *= 1;
      contours[2] *= 1;
    }
  }
  return contours;
}

export function round(number, decimalNumber) {
  const multiplier = 10 ** (decimalNumber || 0);
  return Math.round(number * multiplier) / multiplier;
}

export function getSortFunction(propSorted) {
  return (a, b) => {
    if (typeof a[propSorted] === 'string') { return a[propSorted].localeCompare(b[propSorted]); }
    if (a[propSorted] < b[propSorted]) return -1;
    if (a[propSorted] > b[propSorted]) return 1;
    return 0;
  };
}

export function azimuth(srcCoord, destCoord) {
  const long1 = toRadians(srcCoord[0])
  const lat1 = toRadians(srcCoord[1])
  const long2 = toRadians(destCoord[0])
  const lat2 = toRadians(destCoord[1])

  const dLong = long2 - long1

  const y = Math.sin(dLong) * Math.cos(lat2)
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLong)
  const theta = Math.atan2(y, x)

  const azimuth_ = toDegrees(theta)
  return (azimuth_ + 360) % 360
}

function toRadians(deg) {
  return deg * Math.PI / 180
}

function toDegrees(rad) {
  return rad * 180 / Math.PI
}

export function center([x1, y1], [x2, y2]) {
  return [(x2 + x1) / 2, (y2 + y1) / 2];
}

export function getZeroPaddedLocalTime(date) {
  if (Number.isNaN(date)) {
    throw TypeError('Invalid date');
  }

  const year = `${date.getFullYear()}`.padStart(4, '0');
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  const hours = `${date.getHours()}`.padStart(2, '0');
  const minutes = `${date.getMinutes()}`.padStart(2, '0');
  const seconds = `${date.getSeconds()}`.padStart(2, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

export function indexOf(coordArray, coord) {
  let i; const
    len = coordArray.length;
  for (i = 0; i < len; i++) {
    if (coord[0] === coordArray[i][0] && coord[1] === coordArray[i][1]) {
      return i;
    }
  }
  return -1;
}

export function resizeModule(deltaSize = 0) {
  const PALETTE_DEFAULT_SIZE = getComputedStyle(document.documentElement).getPropertyValue('--palette-width')
  document.documentElement.style.setProperty('--palette-width', `calc(${PALETTE_DEFAULT_SIZE} + ${deltaSize}px)`)
}

export function mergeExtents(extent1, extent2) {
  return [
    Math.min(extent1[0], extent2[0]),
    Math.min(extent1[1], extent2[1]),
    Math.max(extent1[2], extent2[2]),
    Math.max(extent1[3], extent2[3])
  ]
}

export function arraysEqual(a, b, strict = true) {
  if (a === b) return true;
  if (a === null || b === null) return false;
  if (a.length !== b.length) return false;

  if (strict) {
    for (let i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
  } else {
    return a.every(e => b.includes(e))    
  }
  return true;
}

export function deepEqual(o1, o2) {
  const keys1 = Object.keys(o1)
  const keys2 = Object.keys(o2)

  if (keys1.length !== keys2.length) return false

  for (const key of keys1) {
    const val1 = o1[key]
    const val2 = o2[key]
    const areObjects = isObject(val1) && isObject(val2)
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) return false
  }

  return true
}

function isObject(object) {
  return object !== null && typeof object === 'object'
}

export function countDecimals(number) {
  if (Math.floor(number) === number) return 0
  const str = number.toString()
  if (str.indexOf('.') !== -1 && str.indexOf('-') !== -1) return str.split('-')[1] || 0
  else if (str.indexOf('.') !== -1) return str.split('.')[1].length || 0
  return str.split('-')[1] || 0
}

export function urlBase64ToUint8Array(base64String) {
  // eslint-disable-next-line no-mixed-operators
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max)
}

export function debounce(callback, delay) {
  let timer
  return function() {
    const args = arguments
    const context = this
    clearTimeout(timer)
    timer = setTimeout(function() {
      callback.apply(context, args)
    }, delay)
  }
}